module.exports = "<div>\r\n    <div class=\"preventImg\"><img onclick=\"window.opener=null;window.open('','_self');window.close();\" class=\"loading\" src=\"/public/images/mfa/prevent.jpg\"></div>\r\n    <div class=\"preventInformation\">{{mag}}</div>\r\n    <!-- <a onclick=\"window.opener=null;window.open('','_self');window.close();\"  class=\"preventClose\">关闭返回列表</a> -->\r\n    <a data-bind=\"click: apply\"  class=\"preventClose\">申请使用</a>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/component/prevent/prevent.html
// module id = 149
// module chunks = 0